import { Cancel, CheckCircle } from '@mui/icons-material';

import type { SvgIconProps } from '@mui/material';
import type { JobHiringAttendance } from '../type';

export type StatusIconProps = SvgIconProps & {
  status: JobHiringAttendance['status'];
};

const StatusIcon = ({ status, ...props }: StatusIconProps) => {
  switch (status) {
    case 'pending':
      return null;
    case 'auto_approved':
      return <CheckCircle color="success" {...props} />;
    case 'manual_approved':
      return <CheckCircle color="success" {...props} />;
    case 'auto_rejected':
      return <Cancel color="error" {...props} />;
    case 'manual_rejected':
      return <Cancel color="error" {...props} />;
    default:
      return null;
  }
};

export default StatusIcon;
